/* eslint-disable no-unused-vars */
import Select from "react-select";
import React from "react";

const customStyles = {
  control: (base) => ({
    ...base,
    height: 35,
    minHeight: 35,
  }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
};

export default function PRSelect(props) {
  return (
    <Select
      options={props.options}
      filterOption={props.filterOption}
      formatOptionLabel={props.formatOptionLabel}
      components={props.components}
      menuPortalTarget={document.body}
      styles={customStyles}
      onKeyDown={(e) => {
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
      }}
      onChange={props.onChange}
      value={props.value}
      ref={props.ref}
    />
  );
}
